import React from "react";
import "./CustomAlertModal.css";

export default function CustomAlertModal({ type, message, onClose }) {
    const isSuccess = type === "success";

    return (
        <div className="modal-overlay">
            <div className={`modal-box ${isSuccess ? "success" : "error"}`}>
                <div className="modal-icon">
                    {isSuccess ? "✅" : "❌"}
                </div>
                <h3 className="modal-title">
                    {isSuccess ? "Payment Successful!" : "Payment Failed!"}
                </h3>
                <p className="modal-message">{message}</p>

                <button className="modal-btn" onClick={onClose}>
                    OK
                </button>
            </div>
        </div>
    );
}
